export default "__VITE_ASSET__5251042d__"